export interface UserLoginInfo {
  username: string;
  name?: string;
  email?: string;
  picture?: string;
  groups: GroupType[];
  userId: string;
  loginProvider?: string;
}

export enum GroupType {
  AGENCY = 'agency',
  CCC = 'ccc',
  PRIVATE = 'private',
}

export enum LoginTargetAction {
  signup = 'signup',
  login = 'login',
}

export enum ReferringFeature {
  POI_PDP = 'poi_pdp',
  FAVOURITES = 'favourites',
  ACCOUNT_PROMOTION_PDP = 'account_promotion_pdp',
  GOOGLE_ONE_TAP = 'google_one_tap_pdp',
}

export enum AuthEventAction {
  LOGIN = 'auth_login',
  SIGNUP = 'auth_sign_up',
}

export enum AuthEventStatus {
  CLIENT_LOGIN = 'loggedin',
  CLIENT_LOGOUT = 'loggedout',
}
